import React, { useMemo } from "react";
import { cls } from "@wss/cls";
import Hours from "../Header/Banner/Chat/Hours";
import ChatButton from "~/common/Buttons/ChatButton";
import connectUserAndChat, { Chat } from "~/common/Store/connectUserAndChat";

type Props = {
  chat: Chat;
  className?: string;
  toggleBorderOff?: boolean;
};

export default connectUserAndChat(function UseOurLiveChat({
  chat,
  className,
  toggleBorderOff,
}: Props) {
  /* Get a pseudo-random number that cycles 1-4 every 15sec. This meant to give the appearance
   * of randomness and prevents a common bug stemming from server-side rendering where
   * randomly generated values differ between server-side and hydration, causing layout shift.
   */
  const pseudoRandomNumber = () => Math.floor(new Date().getSeconds() / 15) + 1;

  const repImage = useMemo(() => {
    return `/uploads/design/2023/5/live-chat-${pseudoRandomNumber()}.png`;
  }, []);

  return (
    <div
      className={cls(
        "bg-blue-50 lg:max-w-lg min-h-[321px] rounded-md",
        toggleBorderOff ? "" : "border-gray-200 border-solid border",
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center px-4 pt-5 text-center">
        <h2 className="font-bold text-2xl m-0 mt-2">Use Our Live Chat</h2>
        <p className="text-2xs leading-none mb-2.5">
          <Hours chat={chat} />
        </p>
        <ChatButton statusText={chat.statusText} />
        <img
          className="mt-5 max-w-3xs"
          alt=""
          src={repImage}
          data-testid="live-chat-rep-image"
        />
      </div>
    </div>
  );
});
